import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  FormLayout,
  Card,
  TextField,
  Select,
  InlineError,
  PageActions,
  Toast,
  Loading,
  Button,
  Collapsible,
  Spinner,
  Modal,
  Text,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select2 from "react-select";

const AddEditTask = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [item, setItem] = useState({
    department: "Distribution",
    group: "Logistics",
    driver: "",
    name: "",
    location: "Beirut",
    bulk_transfer_from: "",
    type: "",
    status: "registered_allocation",
  });
  const handleSelectChangeBulkTransferFrom = (newValue) => {
    setItem({ ...item, bulk_transfer_from: newValue });
    setBulkError("");
  };
  const [optionsDrivers, setOptionsDrivers] = useState([]);
  const handleSelectChangeDriver = (newValue) => {
    setItem({ ...item, driver: newValue });
    setDriverError("");
  };
  const handleChangeDepartment = (newValue) => {
    setItem({ ...item, department: newValue });
    setDepartmentError("");
  };
  const handleChangeGroup = (newValue) => {
    setItem({ ...item, group: newValue });
    setGroupError("");
  };
  const handleSelectChangeType = (newValue) => {
    setItem({ ...item, type: newValue });
    setTypeError("");
  };
  const handleSelectChangeStatus = (newValue) => {
    setItem({ ...item, status: newValue });
  };
  const handleChangeName = (newValue) => {
    setItem({ ...item, name: newValue });
    setNameError("");
  };
  const handleChangeLocation = (newValue) => {
    setItem({ ...item, location: newValue });
    setLocationError("");
  };
  const [bulkError, setBulkError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [driverError, setDriverError] = useState("");
  const [departmentError, setDepartmentError] = useState("");
  const [groupError, setGroupError] = useState("");
  const [nameError, setNameError] = useState("");
  const [locationError, setLocationError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseItem = "";
    let responseDrivers = [];

    try {
      responseDrivers = await axios.get(`/drivers`);
      setOptionsDrivers(
        responseDrivers.data.data.map((item, index) => {
          return {
            label: item?.first_name + " " + item?.last_name,
            value: String(item.id),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }

    if (props.type === "edit") {
      responseItem = await axios.get(`/bulk-order-transfer/${id}`);
      setItem({
        ...item,
        driver:
          responseItem?.data?.data?.driver &&
          responseItem?.data?.data?.driver?.id !== null
            ? String(responseItem.data.data.driver?.id)
            : "",
        name: responseItem?.data?.data?.shipment_number
          ? responseItem.data.data.shipment_number
          : "",
        type: responseItem?.data?.data?.type ? responseItem.data.data.type : "",
        status: responseItem?.data?.data?.status
          ? responseItem.data.data.status
          : "",
        bulk_transfer_from: responseItem?.data?.data?.notes
          ? responseItem.data.data.notes
          : "",
      });
    }
    setIsSaving(false);
  }

  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/bulk-order-transfer/${id}`)
      .then((result) => {
        navigate("/admin/bulk-order-transfer");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Task`}
      backAction={{
        onAction: () => navigate("/admin/bulk-order-transfer"),
      }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card>
        <FormLayout>
          {/* <Text>Driver</Text> */}
          <Select
            label="Driver"
            requiredIndicator
            options={optionsDrivers}
            onChange={handleSelectChangeDriver}
            value={item.driver}
            placeholder="Please select"
            error={driverError}
            // styles={{
            //   // Fixes the overlapping problem of the component
            //   menu: (provided) => ({ ...provided, zIndex: 9999 }),
            // }}
          />
          <FormLayout.Group>
            <TextField
              value={item.name}
              onChange={handleChangeName}
              error={nameError}
              label="Name"
              requiredIndicator
            />
            <TextField
              value={item.location}
              onChange={handleChangeLocation}
              error={locationError}
              label="Location"
              readOnly
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Department"
              value={item.department}
              onChange={handleChangeDepartment}
              error={departmentError}
              readOnly
            />
            <TextField
              value={item.group}
              onChange={handleChangeGroup}
              error={groupError}
              label="Group"
              readOnly
            />
          </FormLayout.Group>
          <Select
            label="Status"
            options={[
              {
                label: "Registered allocation",
                value: "registered_allocation",
              },
              {
                label: "In progress",
                value: "in_progress",
              },
              {
                label: "Completed",
                value: "completed",
              },
              {
                label: "Closed",
                value: "closed",
              },
              {
                label: "Cancelled",
                value: "cancelled",
              },
            ]}
            onChange={handleSelectChangeStatus}
            value={item.status}
            placeholder="Please select"
            requiredIndicator
          />
          <Select
            label="Type"
            options={[
              { label: "Bulk Order Transfer", value: "bulk_order_transfer" },
              {
                label: "Return to Supplier",
                value: "return_to_supplier",
              },
            ]}
            onChange={handleSelectChangeType}
            value={item.type}
            placeholder="Please select"
            requiredIndicator
            error={typeError}
          />
          {item.type === "bulk_order_transfer" ? (
            <Select
              label="Bulk Transfer From"
              options={[
                {
                  label: "Supplier Warehouse to Holdal Sorting Center",
                  value: "Supplier Warehouse to Holdal Sorting Center",
                },
                {
                  label: "Sorting Center to Beirut Warehouse",
                  value: "Sorting Center to Beirut Warehouse",
                },
              ]}
              onChange={handleSelectChangeBulkTransferFrom}
              value={item.bulk_transfer_from}
              placeholder="Please select"
              requiredIndicator
              error={bulkError}
            />
          ) : null}
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      item.driver === "" ||
      !item.name ||
      !item.type ||
      (!item.type === "bulk_order_transfer" && !item.bulk_transfer_from)
      // !isValidLocationNumber(item.location)
    ) {
      item.driver === "" && setDriverError("Please select a driver");
      !item.name && setNameError("This field is required");
      !item.type && setTypeError("Please select a type");
      !item.type === "bulk_order_transfer" &&
        !item.bulk_transfer_from &&
        setBulkError("Please select an option");
      // !isValidLocationNumber(item.location) &&
      //   setLocationError("Please enter a valid location number");
    } else {
      setIsSaving(true);
      const form_data = new FormData();
      form_data.append("user_id", item.driver);
      form_data.append("shipment_number", item.name);
      item.type === "bulk_order_transfer" &&
        form_data.append("notes", item.bulk_transfer_from);
      item.type === "bulk_order_transfer" &&
        form_data.append(
          "is_first_scan",
          item.bulk_transfer_from ===
            "Supplier Warehouse to Holdal Sorting Center"
            ? 1
            : 0
        );
      form_data.append("type", item.type);
      form_data.append("status", item.status);
      form_data.append("address", item.location);
      props.type === "edit" && form_data.append("_method", "PATCH");
      // const bodyObj = {
      //   user_id: item.driver,
      //   shipment_number: item.name,
      //   ...(item.type === "bulk_order_transfer" && {
      //     notes: item.bulk_transfer_from,
      //   }),
      //   ...(item.type === "bulk_order_transfer" && {
      //     is_first_scan:
      //       item.bulk_transfer_from === "Feel22 to Holdal Sorting Center"
      //         ? 1
      //         : 0,
      //   }),
      //   type: item.type,
      //   status: item.status,
      //   address: item.location,
      //   ...(props.type === "edit" && {
      //     _method: "PATCH",
      //   }),
      // };
      props.type === "add"
        ? axios
            .post(`/bulk-order-transfer`, form_data)
            .then((result) => {
              navigate("/admin/bulk-order-transfer");
            })
            .catch((error) => {
              setIsSaving(false);
            })
        : axios
            .post(`/bulk-order-transfer/${id}`, form_data)
            .then((result) => {
              toggleActive();
              setIsSaving(false);
            })
            .catch((error) => {});
    }
  }
  function isValidLocationNumber(locationNumber) {
    const locationRegex = /^[0-9]{10}$/;
    return locationRegex.test(locationNumber);
  }
};

export default AddEditTask;
